<template>
  <div>
    <h1>Help</h1>

    <div class="flexRow faq" v-for="(answers, question) in questions">
      <div class="label">
        {{ question }}
      </div>
      <ul>
        <li v-for="answer in answers">
          {{ answer }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// FIXME - This is inefficient; not all clients will look at/need this
import questions from "../questions.js";

export default {
  name: "changelog-view",
  computed: {
    questions() {
      return questions;
    },
  },
};
</script>

<style scoped>
.flexRow {
  align-items: baseline;
}

.faq {
  max-width: 800px;
  margin: auto;
}

.label {
  width: 100px;
}

ul {
  display: inline-block;
  margin-left: 2rem;
  text-align: left;
  list-style-type: square;
  max-width: 650px;
}
</style>



// WEBPACK FOOTER //
// HelpView.vue?5bd57b45